// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__RiAt_","title":"ClientInsurance_title__19mnU","itemText":"ClientInsurance_itemText__3x0Km"};